/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistRemixContestEndedNotificationAction } from './ArtistRemixContestEndedNotificationAction';
import {
    ArtistRemixContestEndedNotificationActionFromJSON,
    ArtistRemixContestEndedNotificationActionFromJSONTyped,
    ArtistRemixContestEndedNotificationActionToJSON,
} from './ArtistRemixContestEndedNotificationAction';

/**
 * 
 * @export
 * @interface ArtistRemixContestEndedNotification
 */
export interface ArtistRemixContestEndedNotification {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndedNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndedNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistRemixContestEndedNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestEndedNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ArtistRemixContestEndedNotificationAction>}
     * @memberof ArtistRemixContestEndedNotification
     */
    actions: Array<ArtistRemixContestEndedNotificationAction>;
}

/**
 * Check if a given object implements the ArtistRemixContestEndedNotification interface.
 */
export function instanceOfArtistRemixContestEndedNotification(value: object): value is ArtistRemixContestEndedNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestEndedNotificationFromJSON(json: any): ArtistRemixContestEndedNotification {
    return ArtistRemixContestEndedNotificationFromJSONTyped(json, false);
}

export function ArtistRemixContestEndedNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestEndedNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ArtistRemixContestEndedNotificationActionFromJSON)),
    };
}

export function ArtistRemixContestEndedNotificationToJSON(value?: ArtistRemixContestEndedNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ArtistRemixContestEndedNotificationActionToJSON)),
    };
}

